module.exports = __webpack_public_path__ + "static/media/envelope.c4020e8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/envelope.svg
// module id = 460
// module chunks = 0